<template>
    <div>
        <nav-bar
            :style="{ height: navHeight }"
            :isEnableAppMenu="isEnableAppMenu"
            :show-app-menu.sync="showAppMenu"
            :title="title"
            :isEnableMenu="isEnableMenu"
            :menuItems="menuItems"
            @menu-item-click="handleMenuItemClick"
            @user-setting-click="handleUserSettingClick"
        ></nav-bar>

        <div v-if="showAppMenu" class="mask" @click="showAppMenu = false"></div>
        <transition name="slide-fade">
            <div v-if="showAppMenu" class="app-list" :style="appMenuComponentStyle">
                <component
                    class="list-content"
                    :is="appMenuComponentName"
                    @item-click="appItemClick"
                ></component>
            </div>
        </transition>
    </div>
</template>

<script>
import NavBar from './nav-bar.vue';
import Profile from '@/components/personal/profile.vue';
import ChangePassword from '@/components/personal/change-password.vue';
import MemoRandum from '@/components/personal/memorandum.vue';
import webPageService from '../../services/web-page.service';
import enterpriseService from '../../services/enterprise.service';
import loginService from '@/services/login.service.js';
import commonMethod from '@/components/commethod/commethod';
import NavMenuType from '@/models/nav-menu-type.enum.js';
import { IsNull } from '../../utils/utils';
import asyncComponent from '../../plugins/async-component/async-component';
import { AppListStyle } from '../../models/theme';
export default {
    name: 'nav-bar-container',

    components: {
        NavBar,
        AppList: () =>
            asyncComponent(
                import(/* webpackChunkName: "nav-app-list" */ '@/components/common/app-list.vue')
            ),
        AppMenu: () =>
            asyncComponent(
                import(/* webpackChunkName: "nav-app-menu" */ '@/components/common/app-menu.vue')
            ),
    },

    props: {
        isEnableAppMenu: {
            type: Boolean,
            default: true,
        },
        title: String,
    },

    data() {
        return {
            config: {},
            showAppMenu: false,
        };
    },

    computed: {
        isEnableMenu() {
            return this.config && this.config.Menu ? this.config.Menu.IsEnable : false;
        },
        menuItems() {
            if (this.config && this.config.Menu && Array.isArray(this.config.Menu.Items)) {
                return this.config.Menu.Items;
            } else {
                return [];
            }
        },
        navHeight() {
            return this.isEnableMenu ? '60px' : '48px';
        },
        appMenuComponentType() {
            return this.$store.getters.appListStyle;
        },
        appMenuComponentName() {
            return this.appMenuComponentType === AppListStyle.Menu ? 'AppMenu' : 'AppList';
        },
        appMenuComponentStyle() {
            const isAppMenu = this.appMenuComponentType === AppListStyle.Menu;
            const style = {
                top: this.navHeight,
                width: isAppMenu ? '245px' : '70%',
            };
            if (this.appMenuComponentType === AppListStyle.Default) {
                style['box-shadow'] = '5px 8px 10px #ccc';
            }

            return style;
        },
    },

    created() {
        this.loadNavigatorConfig();
    },

    methods: {
        loadNavigatorConfig() {
            webPageService.getNavigatorConfig().then(res => {
                if (!res.Success) return;
                this.config = res.Result;
            });
        },

        async handleMenuItemClick(menuItem) {
            let url = menuItem.WebURL;
            if (menuItem.IsSSo) {
                //const authEffectiveTime = await enterpriseService.getAuthCodeTime();
                enterpriseService.getPrivateKey().then(privateKey => {
                    const keyCode = commonMethod.encodeUserKey(privateKey);
                    let str = 'authcode=' + keyCode;
                    if (!IsNull(url)) {
                        if (url.indexOf('?') < 0) url += '?' + str;
                        else url += '&' + str;
                        this.openUrl(menuItem.Type, url);
                    }
                });
            } else {
                this.openUrl(menuItem.Type, url);
            }
        },
        openUrl(type, url) {
            switch (type) {
                case NavMenuType.CurrentlyPage:
                    if (!IsNull(url)) {
                        window.location.href = url;
                    }
                    break;
                case NavMenuType.NewPage:
                    if (!IsNull(url)) {
                        window.open(url);
                    }
                    break;
                case NavMenuType.MainPage:
                    this.$router.push({
                        name: 'home',
                    });
                    break;

                default:
                    break;
            }
        },

        handleUserSettingClick(command) {
            switch (command) {
                case 'personalprofile':
                    this.showPersonalProfile();
                    break;
                case 'changepassword':
                    this.showChangepassword();
                    break;
                case 'anency':
                    this.showAnency();
                    break;
                case 'enterbackstage':
                    this.showEnterbackstage();
                    break;
                case 'logoff':
                    this.showLogoff();
                    break;
                case 'memorandum':
                    this.showMemoRandum();
                    break;
                default:
                    break;
            }
        },

        showPersonalProfile() {
            this.$modal.show({
                title: '更新个人资料',
                content: Profile,
                width: '500px',
                confirmAction() {},
            });
        },

        showChangepassword() {
            this.$modal.show({
                title: '修改个人密码',
                content: ChangePassword,
                width: '400px',
                confirmAction() {},
            });
        },

        showMemoRandum() {
            this.$modal.show({
                title: '个人备忘录',
                content: MemoRandum,
                width: '600px',
                confirmAction() {},
            });
        },

        showAnency() {
            this.$router.push({
                name: 'agent',
            });
        },

        showEnterbackstage() {
            this.$router.push({
                name: 'console',
            });
        },

        showLogoff() {
            if (JSON.stringify(this.$route.query) == '{}') {
                loginService.logout(this.$route.fullPath);
            } else {
                for (let item in this.$route.query) {
                    if (item === 'authcode') {
                        delete this.$route.query.authcode;
                        var newArr = [];
                        Object.keys(this.$route.query).forEach(key => {
                            newArr.push(key + '=' + this.$route.query[key]);
                        });
                        var pathStr = newArr.join('&');
                        let fullPath;
                        if (pathStr.length === 0) {
                            fullPath = this.$route.path;
                        } else {
                            fullPath = this.$route.path + '?' + pathStr;
                        }
                        loginService.logout(fullPath);
                    } else {
                        loginService.logout(this.$route.fullPath);
                    }
                }
            }
        },

        appItemClick(tag) {
            this.showAppMenu = tag;
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-bar {
    display: flex;
    position: relative;
    &--app-menu {
        cursor: pointer;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 48px;
        background: url('~@/assets/img/application_top_left_icon.png') center no-repeat;
    }
    &--logo {
        height: 100%;
        display: flex;
        align-items: center;
        .logoBox {
            display: inline-block;
            padding: 0;
            width: 100%;
        }
    }
    &--title {
        margin-left: 20px;
        font-size: 20px;
        color: #fff;
    }
    &--right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    &--menu {
        align-self: flex-end;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 7px;
        .item {
            cursor: pointer;
            color: white;
            padding: 0 5px;
            border-radius: 4px;
            font-size: 14px;
            &:not(:last-child) {
                margin-right: 10px;
            }
        }
    }
    &--user {
        user-select: none;
        height: 25px;
        display: flex;
        align-items: center;
        margin: 0 15px;
        .link {
            cursor: pointer;
            color: white;
        }
    }
}

.mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999;
}

.app-list {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99999;
}

.list-content {
    width: 100%;
    height: 100%;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter {
    transform: translateX(-100%);
}

.slide-fade-leave-active {
    transform: translateX(-100%);
}
</style>